import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Box, Button, Chip, Grid, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { PremiumCard, trackUxSignal } from '../ui';

function value(input: unknown): string {
  return String(input || '').trim();
}

export const EntityOverviewHero = () => {
  const { entity } = useEntity();
  const navigate = useNavigate();
  const title =
    value(entity?.metadata?.title) ||
    value(entity?.metadata?.name) ||
    'Component';
  const kind = value(entity?.kind) || '-';
  const lifecycle = value(entity?.spec?.lifecycle) || '-';
  const owner = value(entity?.spec?.owner) || '-';
  const system = value(entity?.spec?.system) || '-';
  const entityName = value(entity?.metadata?.name) || 'component';
  const tags = Array.isArray(entity?.metadata?.tags)
    ? entity.metadata.tags
    : [];

  const openTab = (tab: 'platform-logs' | 'application-logs') => {
    trackUxSignal('ui.entity.quickAction.opened', { entityName, tab });
    navigate(tab);
  };

  return (
    <PremiumCard title={title} subheader="Platform-ready component view">
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Typography variant="body2" color="textSecondary">
            Unified visibility for build status, runtime logs, and Kubernetes
            resources.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexWrap="wrap"
            gridGap={8}
          >
            <Chip label={`Kind: ${kind}`} size="small" variant="outlined" />
            <Chip
              label={`Lifecycle: ${lifecycle}`}
              size="small"
              variant="outlined"
            />
            <Chip label={`Owner: ${owner}`} size="small" variant="outlined" />
            <Chip label={`System: ${system}`} size="small" variant="outlined" />
          </Box>
        </Grid>
      </Grid>
      {tags.length > 0 ? (
        <Box
          mt={2}
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          gridGap={8}
        >
          {tags.slice(0, 8).map(tag => (
            <Chip key={tag} size="small" label={tag} />
          ))}
        </Box>
      ) : null}
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gridGap={8}
      >
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => openTab('platform-logs')}
        >
          Build Logs
        </Button>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => openTab('application-logs')}
        >
          Application Logs
        </Button>
      </Box>
    </PremiumCard>
  );
};
